import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=c5620558&scoped=true&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=c5620558&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5620558",
  null
  
)

export default component.exports